<template>
    <div class="ei-goods-detail">
        <div class="goods-detail-left">
            <div class="goods-picture">
                <img :src="item.url" v-for="(item,index) in thumbList" :key="index" v-show="item.current" alt="">
            </div>
            <div class="goods-thumb">
                <div>

                </div>
                <div>
                    <ul class="thumb-list">
                        <li :class="{'thumb-item':true,'current':item.current}" v-for="(item,index) in thumbList"
                            :key="index" @mouseenter="thumbHover('thumbList',index)">
                            <img :src="item.url" alt="">
                        </li>
                    </ul>
                </div>
                <div>

                </div>
            </div>
        </div>
        <div class="goods-detail-right">
            <div class="goods-info">
                <div class="goods-title">
                    <span v-html="'褚遂良摹&emsp;《兰亭序》神龙本&emsp;单页彩本'"></span>
                </div>
                <div class="goods-price">
                    <div class="info-key-value">
                        <div class="info-key"><span v-html="'价&emsp;&emsp;格'"></span></div>
                        <div class="info-value">
                            <span class="money-em">¥</span>
                            <span class="money-value">20298.00</span>
                        </div>
                    </div>
                </div>
                <div class="goods-service">
                    <div class="info-key-value">
                        <div class="info-key">服务说明</div>
                        <div class="info-value-list">
                            <div class="info-value">
                                <div class="info-tip">包邮</div>
                                <div class="info-tip">由凌烟阁书画有限公司提供商品、发货开票及售后服务</div>
                            </div>
                        </div>
                    </div>
                    <div class="info-key-value">
                        <div class="info-value-list">
                            <div class="info-key">商品编码</div>
                            <div class="info-value">
                                <span>3102150194301</span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div class="goods-params">
                    <div class="info-key-value">
                        <div class="info-key">选择规格</div>
                        <div class="info-value-list">
                            <div :class="{'info-value choose':true,'current':item.current}"
                                 @click="changeValue('guigeList',index)"
                                 v-for="(item,index) in guigeList" :key="item.value+'-'+index">{{item.value}}
                            </div>
                        </div>
                    </div>
                    <div class="info-key-value">
                        <div class="info-key">选择材质</div>
                        <div class="info-value-list">
                            <div :class="{'info-value choose':true,'current':item.current}"
                                 @click="changeValue('caizhiList',index)"
                                 v-for="(item,index) in caizhiList" :key="item.value+'-'+index">{{item.value}}
                            </div>
                        </div>
                    </div>
                </div>
                <hr style="margin-top:20px "/>
                <div class="goods-chosen">
                    <div class="info-key-value">
                        <div class="info-key">已选商品</div>
                        <div class="info-value-list">
                            <div class="info-value choose current" v-for="(item,index) in guigeList"
                                 :key="item.value+'-'+index" v-show="item.current">{{item.value}}
                            </div>
                            <div class="info-value choose current" v-for="(item,index) in caizhiList"
                                 :key="item.value+'-'+index" v-show="item.current">{{item.value}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="goods-num-add">
                    <div class="info-key-value">
                        <div class="info-key">商品数量</div>
                        <div class="info-value-list">
                            <ei-counter :start="0" :end="999"></ei-counter>
                            <button class="goods-add">加入购物车</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EiGoodsDetail",
        data() {
            return {
                thumbList: [
                    {
                        url: 'upload/goodsDetail/1d935f7c-2978-4d7d-ba4f-8ddcf10f32d3/6f4dcfd3-4687-4d47-9f2e-5f03984a60b5.png',
                        current: true
                    },
                    {
                        url: 'upload/goodsDetail/10/7db62d69-f1af-47cc-98fc-c24938803746.jpg',
                        current: false
                    },
                    {
                        url: 'upload/goodsDetail/10/77eb1465-c75a-4c76-ab68-61faa252e89c.jpg',
                        current: false
                    },
                    {
                        url: 'upload/goodsDetail/10/a68e1977-0535-4673-832a-36f48ed5a31b.jpg',
                        current: false
                    },
                    {
                        url: 'upload/goodsDetail/10/e06e9096-9fab-449c-aeb6-cc92e18befa7.jpg',
                        current: false
                    },
                ],
                guigeList: [
                    {
                        value: '200 x 100',
                        current: true
                    },
                    {
                        value: '200 x 200',
                        current: false
                    },
                    {
                        value: '200 x 300',
                        current: false
                    },
                    {
                        value: '200 x 400',
                        current: false,
                    },
                ],
                caizhiList: [
                    {
                        value: '宣 纸',
                        current: true
                    },
                    {
                        value: '硬 纸',
                        current: false
                    },
                ]
            }
        },
        methods: {
            test(){
                console.log(123)
            },
            thumbHover(list, index) {
                console.log(this._data[list], index)
                for (let i = 0; i < this._data[list].length; i++) {
                    this._data[list][i].current = index === i
                }
                this.$set(this, list, this._data[list])
            },
            changeValue(list, index) {
                console.log(this._data[list], index)
                for (let i = 0; i < this._data[list].length; i++) {
                    this._data[list][i].current = index === i
                }
                this.$set(this, list, this._data[list])
            }
        }
    }
</script>

<style scoped lang="scss">
    .goods-detail-left {
        display: inline-block;
        vertical-align: top;
    }

    .goods-picture {
        width: 480px;
        height: 480px;

        img {
            display: block;
            margin: auto;
            height: 480px;
        }
    }

    .thumb-list {
        .thumb-item {
            margin-left: 3px;
            margin-right: 3px;
            display: inline-block;
            width: 66px;
            height: 66px;
            text-align: center;
            border: 1px solid #fff;
            transition: border .3s linear;
            cursor: pointer;

            &.current {
                border: 1px solid red;
            }

            img {
                margin-top: 3px;
                width: 60px;
                height: 60px;
            }
        }
    }

    .goods-detail-right {
        display: inline-block;
        vertical-align: top;
    }

    .goods-info {
        .goods-title {
            margin-top: 20px;
            font-size: 21px;
            overflow: hidden;
            margin-bottom: 10px;
        }

        .goods-price {
            width: 700px;
            height: 90px;
            background-color: #F5F5F5;
        }

        .info-key-value {
            width: 700px;
            word-wrap: break-word;
            position: relative;

            .info-key {
                display: inline-block;
                width: 70px;
                height: 40px;
                margin-left: 20px;
                margin-right: 20px;
                margin-top: 10px;
                vertical-align: top;
                line-height: 40px;
            }

            .info-value-list {
                display: inline-block;
                vertical-align: top;
            }

            .info-value {
                display: inline-block;
                position: relative;
                vertical-align: top;
                margin-top: 10px;
                line-height: 40px;
                word-wrap: break-word;
                max-width: 570px;

                .info-tip {
                    &:not(:first-child) {
                        line-height: 35px;
                    }
                }

                &.choose {
                    text-align: center;
                    border: 1px solid #A4A4A4;
                    padding: 0 25px;
                    height: 45px;
                    line-height: 45px;
                    cursor: pointer;
                    transition: border .3s linear;

                    &:hover {
                        border: 1px solid #E9DAB2;
                    }

                    &:not(:first-child) {
                        margin-left: 10px;
                    }

                    &:before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 0;
                        border-top: 1px solid #FF0035;
                        border-left: 1px solid #FF0035;
                        width: 0;
                        height: 0;
                        transition: all 0.4s ease-out 0s;
                        visibility: hidden;
                        box-sizing: border-box;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        border-right: 1px solid rgb(255, 18, 49);
                        border-bottom: 1px solid rgb(255, 18, 49);
                        width: 0;
                        height: 0;
                        transition: all 0.4s ease-out 0s;
                        visibility: hidden;
                        box-sizing: border-box;
                    }

                    &.current {
                        border: 1px solid #D30421 !important;

                        &:before {
                            width: 100%;
                            height: 100%;
                            visibility: visible;
                        }

                        &:after {
                            width: 100%;
                            height: 100%;
                            visibility: visible;
                        }
                    }
                }

                .money-em {
                    font-size: 18px;
                    margin-right: 4px;
                    color: #ca141d;
                }

                .money-value {
                    font-size: 24px;
                    color: #ca141d;
                }

            }
        }


        .goods-num-add {
            margin-top: 20px;

            .ei-counter {
                display: inline-block;
                background-color: #DC0025;
                margin-top: 8px;
                &:after{
                    background: linear-gradient(180deg, rgba(230,0,41, .9) 0%, rgba(230,0,41, 0) 30%, rgba(230,0,41, 0) 70%, rgba(230,0,41, .9) 100%);
                }
            }

            .goods-add {
                display: inline-block;
                position: absolute;
                right: 20px;
                width: 170px;
                height: 45px;
                font-size: 18px;
                color: #fff;
                background-color: #D30421;
                transition: background-color .3s linear;

                &:hover {
                    background-color: #DE404D;
                }
            }

        }
    }


</style>
